import { Paragraph, Heading } from '@hungryroot/ramen';
import { SectionList } from '../SectionList/SectionList';
import { CaliforniaEmployeeNoticeSections } from './CaliforniaEmployeeNoticeSections';

import styles from './CaliforniaEmployeeNotice.module.css';

interface Props {
  testid?: string;
}

export function CaliforniaEmployeeNotice(props: Props) {
  const { testid } = props;
  return (
    <div className={styles.container} data-testid={testid}>
      <div className={styles.heading}>
        <Heading variant="H2" className={styles.title}>
          California Employee Privacy Policy and Notice
        </Heading>
        <Heading variant="H6" className={styles['margin-bottom']}>
          (Applicable to California Residents)
        </Heading>
        <Paragraph>Last Updated: March 5th, 2025</Paragraph>
      </div>
      <SectionList
        testid="ca-employee-notice-list"
        data={CaliforniaEmployeeNoticeSections}
      />
    </div>
  );
}
